import { useMemo, useState } from 'react'
import ImageOptimize from '../ImageOptimize'

export interface FormPassword {
  placeholder?: string
  className?: string
  iconClassName?: string
  isError?: boolean | string
  id?: string
  name?: string
  value?: string
  children?: JSX.Element[] | JSX.Element
  alert?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  iconWidth?: string
  iconHeight?: string
  iconViewBox?: string
  isNewIcon?: boolean
  showIconUrl: string | null | undefined
  hideIconUrl: string | null | undefined
}

export function FormPassword({
  isError = false,
  className = '',
  placeholder = '',
  alert = false,
  children,
  name = '',
  id = '',
  value,
  onChange,
  showIconUrl,
  hideIconUrl,
}: FormPassword) {
  const [show, setShow] = useState(false)
  const hidePasswordHandler = () => {
    setShow(!show)
  }
  const helperChild = useMemo(
    () =>
      children &&
      ('filter' in children
        ? children.filter(f => f.type.displayName === 'FormTextHelper')
        : children.type.displayName === 'FormTextHelper'
        ? [children]
        : []),
    [children]
  )
  const errorChild = useMemo(
    () =>
      children &&
      ('filter' in children
        ? children.filter(f => f.type.displayName === 'FormTextRequire')
        : children.type.displayName === 'FormTextRequire'
        ? [children]
        : []),
    [children]
  )
  // Default width is 100% , height is 40px
  return (
    <div className=''>
      <div className='relative'>
        <input
          placeholder={placeholder}
          type={show ? 'text' : 'password'}
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          className={`rounded-container type-primary-regular
            !h-12
            w-full border p-3
        pr-12 shadow-none focus:shadow-none focus:outline-none
        focus:ring-0 ${className} ${isError ? '!border-states-error' : ''}`}
        />
        <button
          type='button'
          className='absolute right-3 top-0 flex h-full items-center'
          onClick={hidePasswordHandler}
        >
          {show ? (
            <ImageOptimize
              alt='show icon'
              src={showIconUrl || ''}
              width={20}
              height={14}
            />
          ) : (
            <ImageOptimize
              alt='show icon'
              src={hideIconUrl || ''}
              width={20}
              height={14}
            />
          )}
        </button>
      </div>
      {alert && (
        <div className={`${isError && errorChild && 'pt-2'}`}>
          {isError && errorChild}
          {helperChild}
        </div>
      )}
    </div>
  )
}

export default FormPassword
